// ************************************************************************************************
// pathname: v2/publication/conert-to-paid/${jobSlug}
// ************************************************************************************************
import { useTranslation } from 'next-i18next';
import { useSwrMutationApi } from '@hooks/useSwrApi';

/** Hook props */
interface UseSwrInstantlySearchpackProps {
  locale?: Locale;
  jobSlug: string;
  onSuccess?: () => void;
}

/**
 * @description Hook for activating a searchPack.
 * - `locale`: The current app locale.
 * - `jobSlug`: The job slug.
 * - `onSuccess`: Optional callback to execute on success.
 */
export const useSwrConvertToPaid = (props: UseSwrInstantlySearchpackProps) => {
  const {
    jobSlug, onSuccess,
  } = props;
  const { i18n } = useTranslation('common');

  // SWR, activate the job
  return useSwrMutationApi<null, object>({
    url: `/v2/publication/convert-to-paid/${jobSlug}`,
    locale: i18n.language,
    fetcherConfig: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess,
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });
};
